/* Arange · Wishlist — puente con la app Wishlist Hero.

   Hace dos cosas, porque sin la JS API de la app (es de pago) no hay otra vía:
   1. La app suelta su botón bajo el formulario de compra; aquí lo movemos al hueco
      que marca el Figma (fila "Wishlist + Share", node 59:2751). El vestido va en
      arange-pdp.css.
   2. Sus textos son fijos en inglés, así que los reescribimos con los del theme
      (locales `arange.wishlist.*`) según el estado, que la app marca en el aria-label.

   OJO: la app crea el contenedor VACÍO y mete el <button> más tarde, así que el
   observador tiene que seguir esperando hasta que el botón exista. Y solo escribimos
   cuando el texto cambia de verdad: si no, el observador se retroalimenta. */
(function () {
  var SLOT = '[data-arange-wishlist-slot]';
  var APP_BOX = '.wishlisthero-product-page-button-container';
  var TIMEOUT = 20000;

  function textNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var last = null;
    while (walker.nextNode()) {
      if (walker.currentNode.textContent.trim()) last = walker.currentNode;
    }
    return last;
  }

  function label(slot, btn) {
    var saved = /remove|quitar/i.test(btn.getAttribute('aria-label') || '');
    var text = saved ? slot.dataset.labelRemove : slot.dataset.labelAdd;
    if (!text) return;
    /* Solo el nodo de texto: el <span> lleva dentro el SVG del corazón. */
    var node = textNode(btn);
    if (!node || node.textContent.trim() === text) return;
    node.textContent = ' ' + text;
    btn.setAttribute('aria-label', text);
  }

  function bind() {
    var slot = document.querySelector(SLOT);
    var box = document.querySelector(APP_BOX);
    if (!slot || !box) return false;

    if (box.parentNode !== slot) slot.appendChild(box);
    slot.setAttribute('data-ready', '');

    var btn = box.querySelector('button');
    if (!btn) return false;

    label(slot, btn);
    if (!btn.dataset.arangeLabelBound) {
      btn.dataset.arangeLabelBound = '1';
      new MutationObserver(function () { label(slot, btn); }).observe(btn, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-label']
      });
    }
    return true;
  }

  function watch() {
    if (bind()) return;
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      if (bind()) { done = true; obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { if (!done) { done = true; obs.disconnect(); } }, TIMEOUT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
